const facebookEnquiry = ({
  threadId,
  eventType,
  organiserType,
  budget,
  capacity,
}) => {
  if (window.fbq) {
    window.fbq("track", "Lead", {
      thread_id: threadId,
      event_type: eventType,
      organiser_type: organiserType,
      budget,
      capacity,
    });
  }
};
const facebookVenueFinder = ({
  eventType,
  organiserType,
  budget,
  capacity,
}) => {
  if (window.fbq) {
    window.fbq("track", "VenueFinder", {
      event_type: eventType,
      organiser_type: organiserType,
      budget,
      capacity,
    });
  }
};
const facebookEvent = (event, data) => {
  if (window.fbq) {
    window.fbq("track", event, data);
  }
};
export { facebookEnquiry, facebookVenueFinder, facebookEvent };
